import React, {useMemo} from "react";
import NextImage from "next/image";
import {s3ImageSource} from "../../../../../../../useS3ImgSrc";
import {useImageSize} from "@components/Booking/LocationSelection/LocationRow/Contents/Image/styles";

const Image = ({imgId, locationName}: {imgId: string; locationName: string}) => {
  const size = useImageSize();
  const style = useMemo(() => ({flexBasis: size}), [size]);

  return (
    <div className="flex flex-col items-center" style={style}>
      <NextImage
        className="rounded-lg object-cover"
        src={s3ImageSource(imgId)}
        alt={locationName}
        height={size}
        width={size}
      />
    </div>
  );
};

export default React.memo(Image);
